import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Dialog } from '../../ui/dialog/dialog';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { CLAccountFilter } from './account.service';

/**
 * CLAccount filter dialog
 */
@Component({
  templateUrl: './account-filter-dialog.component.html',
  host: {'(window:keydown)': 'hotkeys($event)'},
  styles: [
    `.dialog-container {
      display: block;
      position: fixed;
      z-index: 300;
      width: 100%;
      left: 0;
    }`
  ],
  animations: [
    trigger(
      'openState',
      [
        state(
          'open',
          style({
            top: '0px'
          })
        ),
        state(
          'closed',
          style({
            top: '-306px'
          })
        ),
        transition('closed => open', animate('400ms ease-out')),
        transition('open => closed', animate('400ms ease-in')),
      ]
    ),
  ]
})
export class CLAccountFilterDialogComponent implements Dialog, OnInit {
  state = 'closed';

  filter: CLAccountFilter

  lastSearch: string
  searchTimer: any

  @ViewChild('searchInput')
  searchInput: ElementRef

  orderBy = 'NAME/ASC'
  updateDate = 'ALL_TIME'

  ORDER_BY_OPTIONS = [
    {
      id: 'NAME/DESC',
      text: 'Nom ↓'
    },
    {
      id: 'NAME/ASC',
      text: 'Nom ↑'
    }
  ];
  
  onClose: () => void
  onApply: (filter: CLAccountFilter) => void

  ngOnInit() {
    this.lastSearch = this.filter.search;

    this.orderBy = this.filter.orderBy + '/' + this.filter.orderDir;

    // Focus search input
    this.searchInput.nativeElement.focus();
  }

  close() {
    this.onClose();
  }

  apply() {
    let [orderBy, orderDir] = this.orderBy.split('/');

    if(orderBy === 'NAME') {
      this.filter.orderBy = orderBy;
    }

    if(orderDir === 'ASC' || orderDir === 'DESC') {
      this.filter.orderDir = orderDir;
    }

    this.onApply(this.filter);
  }

  hotkeys(event: KeyboardEvent){

    switch(event.keyCode) {
      // Escape key
      case 27:
        this.close();
        break;
      // Enter key
      case 13:
        this.apply();
        this.close();
        break;
    }
  }

  searchKeyup(event: KeyboardEvent) {
    if(this.lastSearch !== this.filter.search) {
      this.lastSearch = this.filter.search;

      if(this.searchTimer) {
        window.clearTimeout(this.searchTimer);
      }

      this.searchTimer = window.setTimeout(() => {
        this.apply();
      }, 500);
    }
  }
}

